export default "__VITE_ASSET__BBcD5vsH__"